import { css } from '@emotion/react';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { Trans } from 'react-i18next';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import { useModal } from '~/modal/useModal.hook';

const noteStyle = (theme: Theme) => css({
  color: theme.textColors.contrast,
  fontWeight: 500,
  lineHeight: 1.5,
});

const linkStyle = css({
  cursor: 'pointer',
  textDecoration: 'underline',
});

type DataSourceNotesProps = Readonly<{
  isNewSalesRepMap?: boolean;
}>;

export const DataSourceNotesComponent: FC<DataSourceNotesProps> = ({
  isNewSalesRepMap,
}) => {
  const [t] = useTranslation();
  const { openModal: openPrepareDataModal } = useModal('PrepareData');

  return (
    <>
      {isNewSalesRepMap && (
        <strong css={noteStyle}>
          {t('spreadsheet.note.column.header.sales-map')}
          <br /><br />
        </strong>
      )}
      <strong css={noteStyle}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
        />
        <Trans
          i18nKey="spreadsheet.note.column.header"
          components={{
            prepareDataLink: (
              <span
                css={linkStyle}
                onClick={() => openPrepareDataModal()}
              />
            ),
          }}
        />
      </strong>
    </>
  );
};
